export default __webpack_public_path__ + "static/media/28-2.119351fa.mp3";